import { SankeyLink } from '../types/sankey';

export const RVC2: SankeyLink[] = [
    {
        source: 104,
        target: 15,
        value: 1,
        valueid: ['targetcb', 'targetaa'],
        paperName: 'EAIA17',
        process: 'EAIA17_1',
        id: 'EAIA17-0',
        cluster: 'rvc2',
        imgUrl: 'TFuj7MS.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 104,
        target: 21,
        value: 1,
        valueid: 'targetcb',
        paperName: 'EAIA17',
        process: 'EAIA17_4',
        id: 'EAIA17-3',
        cluster: 'rvc2',
        imgUrl: 'TFuj7MS.jpg',
        color: 'targetLinkFourColor',
        status: 'selected',
    },
    {
        source: 15,
        target: 41,
        value: 1,
        valueid: ['targetcb', 'targetaa'],
        paperName: 'EAIA17',
        process: 'EAIA17_1',
        id: 'EAIA17-4',
        cluster: 'rvc2',
        imgUrl: 'TFuj7MS.jpg',
        color: 'intThreeLinkColor',
    },
    {
        source: 15,
        target: 42,
        value: 1,
        valueid: ['targetcb', 'targetaa'],
        paperName: 'EAIA17',
        process: 'EAIA17_1',
        id: 'EAIA17-5',
        cluster: 'rvc2',
        imgUrl: 'TFuj7MS.jpg',
        color: 'intThreeLightLinkColor',
    },
    {
        source: 15,
        target: 43,
        value: 1,
        valueid: ['targetcb', 'targetaa'],
        paperName: 'EAIA17',
        process: 'EAIA17_1',
        id: 'EAIA17-6',
        cluster: 'rvc2',
        imgUrl: 'TFuj7MS.jpg',
        color: 'intThreeLight1LinkColor',
    },
    { source: 21, target: 46, value: 1, valueid: 'targetcb', paperName: 'EAIA17', process: 'EAIA17_4', id: 'EAIA17-11', cluster: 'rvc2', imgUrl: 'TFuj7MS.jpg', color: 'intFiveLinkColor' },
    {
        source: 41,
        target: 52,
        value: 1,
        valueid: ['targetcb', 'targetaa'],
        paperName: 'EAIA17',
        process: 'EAIA17_1',
        id: 'EAIA17-12',
        cluster: 'rvc2',
        imgUrl: 'TFuj7MS.jpg',
        color: 'intThreeLinkColor',
    },
    {
        source: 42,
        target: 52,
        value: 1,
        valueid: ['targetcb', 'targetaa'],
        paperName: 'EAIA17',
        process: 'EAIA17_1',
        id: 'EAIA17-14',
        cluster: 'rvc2',
        imgUrl: 'TFuj7MS.jpg',
        color: 'intThreeLightLinkColor',
    },
    {
        source: 43,
        target: 52,
        value: 1,
        valueid: ['targetcb', 'targetaa'],
        paperName: 'EAIA17',
        process: 'EAIA17_1',
        id: 'EAIA17-16',
        cluster: 'rvc2',
        imgUrl: 'TFuj7MS.jpg',
        color: 'intThreeLight1LinkColor',
    },
    { source: 46, target: 52, value: 1, valueid: 'targetcb', paperName: 'EAIA17', process: 'EAIA17_4', id: 'EAIA17-19', cluster: 'rvc2', imgUrl: 'TFuj7MS.jpg', color: 'intFiveLinkColor' },
    { source: 52, target: 81, value: 1, valueid: ['targetcb', 'targetaa'], paperName: 'EAIA17', process: 'EAIA17_1', id: 'EAIA17-24', cluster: 'rvc2', imgUrl: 'TFuj7MS.jpg', color: 'repVisVarColor' },
    { source: 52, target: 81, value: 1, valueid: 'targetcb', paperName: 'EAIA17', process: 'EAIA17_4', id: 'EAIA17-25', cluster: 'rvc2', imgUrl: 'TFuj7MS.jpg', color: 'repVisVarColor' },
    {
        source: 128,
        target: 11,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repb'],
        paperName: 'SCS17',
        process: 'SCS17_3',
        id: 'SCS17-2',
        cluster: 'rvc2',
        imgUrl: 'h29usSh.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 11,
        target: 41,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repb'],
        paperName: 'SCS17',
        process: 'SCS17_3',
        id: 'SCS17-24',
        cluster: 'rvc2',
        imgUrl: 'h29usSh.jpg',
        color: 'intThreeLinkColor',
    },
    {
        source: 41,
        target: 54,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repb'],
        paperName: 'SCS17',
        process: 'SCS17_3',
        id: 'SCS17-25',
        cluster: 'rvc2',
        imgUrl: 'h29usSh.jpg',
        color: 'intThreeLinkColor',
    },
    {
        source: 54,
        target: 81,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repb'],
        paperName: 'SCS17',
        process: 'SCS17_3',
        id: 'SCS17-26',
        cluster: 'rvc2',
        imgUrl: 'h29usSh.jpg',
        color: 'repVisVarColor',
    },
    {
        source: 130,
        target: 23,
        value: 1,
        valueid: 'repf',
        paperName: 'SSK12',
        process: 'SSK12_2',
        id: 'SSK12-4',
        cluster: 'rvc2',
        imgUrl: 'chAdr4B.png',
        color: 'targetLinkFourColor',
        status: 'selected',
    },
    { source: 23, target: 46, value: 1, valueid: 'repf', paperName: 'SSK12', process: 'SSK12_2', id: 'SSK12-13', cluster: 'rvc2', imgUrl: 'chAdr4B.png', color: 'intFiveLinkColor' },
    { source: 46, target: 60, value: 1, valueid: 'repf', paperName: 'SSK12', process: 'SSK12_2', id: 'SSK12-14', cluster: 'rvc2', imgUrl: 'chAdr4B.png', color: 'intFiveLinkColor' },
    { source: 60, target: 81, value: 1, valueid: 'repf', paperName: 'SSK12', process: 'SSK12_2', id: 'SSK12-17', cluster: 'rvc2', imgUrl: 'chAdr4B.png', color: 'repVisVarColor' },
    {
        source: 131,
        target: 21,
        value: 1,
        valueid: ['targetcb', 'repf'],
        paperName: 'VWH13',
        process: 'VWH13_4',
        id: 'VWH13-7',
        cluster: 'rvc2',
        imgUrl: 'TO07ZUT.jpg',
        color: 'targetLinkFourColor',
        status: 'selected',
    },
    {
        source: 131,
        target: 23,
        value: 1,
        valueid: ['targetcb', 'repf'],
        paperName: 'VWH13',
        process: 'VWH13_4',
        id: 'VWH13-8',
        cluster: 'rvc2',
        imgUrl: 'TO07ZUT.jpg',
        color: 'targetLinkFourColor',
        status: 'selected',
    },
    { source: 21, target: 46, value: 1, valueid: ['targetcb', 'repf'], paperName: 'VWH13', process: 'VWH13_4', id: 'VWH13-36', cluster: 'rvc2', imgUrl: 'TO07ZUT.jpg', color: 'intFiveLinkColor' },
    { source: 23, target: 46, value: 1, valueid: ['targetcb', 'repf'], paperName: 'VWH13', process: 'VWH13_4', id: 'VWH13-37', cluster: 'rvc2', imgUrl: 'TO07ZUT.jpg', color: 'intFiveLinkColor' },
    { source: 21, target: 48, value: 1, valueid: ['targetcb', 'repf'], paperName: 'VWH13', process: 'VWH13_4', id: 'VWH13-38', cluster: 'rvc2', imgUrl: 'TO07ZUT.jpg', color: 'intFiveLightLinkColor' },
    { source: 23, target: 48, value: 1, valueid: ['targetcb', 'repf'], paperName: 'VWH13', process: 'VWH13_4', id: 'VWH13-39', cluster: 'rvc2', imgUrl: 'TO07ZUT.jpg', color: 'intFiveLightLinkColor' },
    {
        source: 21,
        target: 49,
        value: 1,
        valueid: ['targetcb', 'repf'],
        paperName: 'VWH13',
        process: 'VWH13_4',
        id: 'VWH13-40',
        cluster: 'rvc2',
        imgUrl: 'TO07ZUT.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 23,
        target: 49,
        value: 1,
        valueid: ['targetcb', 'repf'],
        paperName: 'VWH13',
        process: 'VWH13_4',
        id: 'VWH13-41',
        cluster: 'rvc2',
        imgUrl: 'TO07ZUT.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 46, target: 60, value: 1, valueid: ['targetcb', 'repf'], paperName: 'VWH13', process: 'VWH13_4', id: 'VWH13-42', cluster: 'rvc2', imgUrl: 'TO07ZUT.jpg', color: 'intFiveLinkColor' },
    { source: 48, target: 60, value: 1, valueid: ['targetcb', 'repf'], paperName: 'VWH13', process: 'VWH13_4', id: 'VWH13-43', cluster: 'rvc2', imgUrl: 'TO07ZUT.jpg', color: 'intFiveLightLinkColor' },
    {
        source: 49,
        target: 60,
        value: 1,
        valueid: ['targetcb', 'repf'],
        paperName: 'VWH13',
        process: 'VWH13_4',
        id: 'VWH13-44',
        cluster: 'rvc2',
        imgUrl: 'TO07ZUT.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 60, target: 81, value: 1, valueid: ['targetcb', 'repf'], paperName: 'VWH13', process: 'VWH13_4', id: 'VWH13-45', cluster: 'rvc2', imgUrl: 'TO07ZUT.jpg', color: 'repVisVarColor' },
    {
        source: 134,
        target: 11,
        value: 1,
        valueid: ['targetab', 'repc'],
        paperName: 'XWS16',
        process: 'XWS16_4',
        id: 'XWS16-1',
        cluster: 'rvc2',
        imgUrl: 'xn5MqwV.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 11,
        target: 49,
        value: 1,
        valueid: ['targetab', 'repc'],
        paperName: 'XWS16',
        process: 'XWS16_4',
        id: 'XWS16-11',
        cluster: 'rvc2',
        imgUrl: 'xn5MqwV.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 49,
        target: 53,
        value: 1,
        valueid: ['targetab', 'repc'],
        paperName: 'XWS16',
        process: 'XWS16_4',
        id: 'XWS16-19',
        cluster: 'rvc2',
        imgUrl: 'xn5MqwV.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 53, target: 81, value: 1, valueid: ['targetab', 'repc'], paperName: 'XWS16', process: 'XWS16_4', id: 'XWS16-30', cluster: 'rvc2', imgUrl: 'xn5MqwV.jpg', color: 'repVisVarColor' },
    {
        source: 136,
        target: 15,
        value: 1,
        valueid: 'repd',
        paperName: 'ZGWZ14',
        process: 'ZGWZ14_2',
        id: 'ZGWZ14-1',
        cluster: 'rvc2',
        imgUrl: 'R9fi5QW.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 15, target: 34, value: 1, valueid: 'repd', paperName: 'ZGWZ14', process: 'ZGWZ14_2', id: 'ZGWZ14-4', cluster: 'rvc2', imgUrl: 'R9fi5QW.png', color: 'intOneLightLinkColor' },
    { source: 15, target: 43, value: 1, valueid: 'repd', paperName: 'ZGWZ14', process: 'ZGWZ14_2', id: 'ZGWZ14-7', cluster: 'rvc2', imgUrl: 'R9fi5QW.png', color: 'intThreeLight1LinkColor' },
    { source: 15, target: 49, value: 1, valueid: 'repd', paperName: 'ZGWZ14', process: 'ZGWZ14_2', id: 'ZGWZ14-9', cluster: 'rvc2', imgUrl: 'R9fi5QW.png', color: 'intFiveLight2LinkColor' },
    { source: 34, target: 55, value: 1, valueid: 'repd', paperName: 'ZGWZ14', process: 'ZGWZ14_2', id: 'ZGWZ14-17', cluster: 'rvc2', imgUrl: 'R9fi5QW.png', color: 'intOneLightLinkColor' },
    { source: 43, target: 55, value: 1, valueid: 'repd', paperName: 'ZGWZ14', process: 'ZGWZ14_2', id: 'ZGWZ14-18', cluster: 'rvc2', imgUrl: 'R9fi5QW.png', color: 'intThreeLight1LinkColor' },
    { source: 49, target: 55, value: 1, valueid: 'repd', paperName: 'ZGWZ14', process: 'ZGWZ14_2', id: 'ZGWZ14-19', cluster: 'rvc2', imgUrl: 'R9fi5QW.png', color: 'intFiveLight2LinkColor' },
    { source: 55, target: 81, value: 1, valueid: 'repd', paperName: 'ZGWZ14', process: 'ZGWZ14_2', id: 'ZGWZ14-26', cluster: 'rvc2', imgUrl: 'R9fi5QW.png', color: 'repVisVarColor' },
    {
        source: 144,
        target: 7,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'YCC20',
        process: 'YCC20_1',
        id: 'YCC20-0',
        cluster: 'rvc2',
        imgUrl: 'RYq4EGR.jpg',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 144,
        target: 11,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'YCC20',
        process: 'YCC20_1',
        id: 'YCC20-2',
        cluster: 'rvc2',
        imgUrl: 'RYq4EGR.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 7, target: 34, value: 1, valueid: ['targetca', 'repc'], paperName: 'YCC20', process: 'YCC20_1', id: 'YCC20-5', cluster: 'rvc2', imgUrl: 'RYq4EGR.jpg', color: 'intOneLightLinkColor' },
    { source: 11, target: 34, value: 1, valueid: ['targetca', 'repc'], paperName: 'YCC20', process: 'YCC20_1', id: 'YCC20-10', cluster: 'rvc2', imgUrl: 'RYq4EGR.jpg', color: 'intOneLightLinkColor' },
    { source: 34, target: 70, value: 1, valueid: ['targetca', 'repc'], paperName: 'YCC20', process: 'YCC20_1', id: 'YCC20-14', cluster: 'rvc2', imgUrl: 'RYq4EGR.jpg', color: 'intOneLightLinkColor' },
    { source: 53, target: 81, value: 1, valueid: ['targetca', 'repc'], paperName: 'YCC20', process: 'YCC20_1', id: 'YCC20-26', cluster: 'rvc2', imgUrl: 'RYq4EGR.jpg', color: 'repVisVarColor' },
    { source: 70, target: 81, value: 1, valueid: ['targetca', 'repc'], paperName: 'YCC20', process: 'YCC20_1', id: 'YCC20-29', cluster: 'rvc2', imgUrl: 'RYq4EGR.jpg', color: 'repVisVarColor' },
    {
        source: 147,
        target: 13,
        value: 1,
        valueid: ['targetbb', 'ref'],
        paperName: 'MDJW07',
        process: 'MDJW07_5',
        id: 'MDJW07-4',
        cluster: 'rvc2',
        imgUrl: 'E21AFdm.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 13,
        target: 49,
        value: 1,
        valueid: ['targetbb', 'repf'],
        paperName: 'MDJW07',
        process: 'MDJW07_5',
        id: 'MDJW07-15',
        cluster: 'rvc2',
        imgUrl: 'E21AFdm.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 49,
        target: 60,
        value: 1,
        valueid: ['targetbb', 'repf'],
        paperName: 'MDJW07',
        process: 'MDJW07_5',
        id: 'MDJW07-27',
        cluster: 'rvc2',
        imgUrl: 'E21AFdm.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 60, target: 81, value: 1, valueid: ['targetbb', 'repf'], paperName: 'MDJW07', process: 'MDJW07_5', id: 'MDJW07-36', cluster: 'rvc2', imgUrl: 'E21AFdm.jpg', color: 'repVisVarColor' },
    {
        source: 149,
        target: 15,
        value: 1,
        valueid: 'repeb',
        paperName: 'BN11B',
        process: 'BN11B_1',
        id: 'BN11B-0',
        cluster: 'rvc2',
        imgUrl: 'PfZa19T.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 15, target: 40, value: 1, valueid: 'repeb', paperName: 'BN11B', process: 'BN11B_1', id: 'BN11B-4', cluster: 'rvc2', imgUrl: 'PfZa19T.jpg', color: 'intTwoLightLinkColor' },
    { source: 40, target: 59, value: 1, valueid: 'repeb', paperName: 'BN11B', process: 'BN11B_1', id: 'BN11B-5', cluster: 'rvc2', imgUrl: 'PfZa19T.jpg', color: 'intTwoLightLinkColor' },
    { source: 59, target: 81, value: 1, valueid: 'repeb', paperName: 'BN11B', process: 'BN11B_1', id: 'BN11B-6', cluster: 'rvc2', imgUrl: 'PfZa19T.jpg', color: 'repVisVarColor' },
    {
        source: 153,
        target: 11,
        value: 1,
        valueid: 'repg',
        paperName: 'FZC18',
        process: 'FZC18_2',
        id: 'FZC18-0',
        cluster: 'rvc2',
        imgUrl: 'zz8t6eU.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 153,
        target: 13,
        value: 1,
        valueid: 'repg',
        paperName: 'FZC18',
        process: 'FZC18_2',
        id: 'FZC18-3',
        cluster: 'rvc2',
        imgUrl: 'zz8t6eU.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 11, target: 45, value: 1, valueid: 'repg', paperName: 'FZC18', process: 'FZC18_2', id: 'FZC18-17', cluster: 'rvc2', imgUrl: 'zz8t6eU.jpg', color: 'intFourLinkColor' },
    { source: 13, target: 45, value: 1, valueid: 'repg', paperName: 'FZC18', process: 'FZC18_2', id: 'FZC18-19', cluster: 'rvc2', imgUrl: 'zz8t6eU.jpg', color: 'intFourLinkColor' },
    { source: 45, target: 68, value: 1, valueid: 'repg', paperName: 'FZC18', process: 'FZC18_2', id: 'FZC18-21', cluster: 'rvc2', imgUrl: 'zz8t6eU.jpg', color: 'intFourLinkColor' },
    { source: 68, target: 81, value: 1, valueid: 'repg', paperName: 'FZC18', process: 'FZC18_2', id: 'FZC18-22', cluster: 'rvc2', imgUrl: 'zz8t6eU.jpg', color: 'repVisVarColor' },
    {
        source: 117,
        target: 24,
        value: 1,
        valueid: 'targetab',
        paperName: 'LLN14',
        process: 'LLN14_4',
        id: 'LLN14-4',
        cluster: 'rvc2',
        imgUrl: 'xWQU5gc.jpg',
        color: 'targetLinkFourColor',
        status: 'selected',
    },
    { source: 24, target: 46, value: 1, valueid: 'targetab', paperName: 'LLN14', process: 'LLN14_4', id: 'LLN14-21', cluster: 'rvc2', imgUrl: 'xWQU5gc.jpg', color: 'intFiveLinkColor' },
    { source: 46, target: 55, value: 1, valueid: 'targetab', paperName: 'LLN14', process: 'LLN14_4', id: 'LLN14-22', cluster: 'rvc2', imgUrl: 'xWQU5gc.jpg', color: 'intFiveLinkColor' },
    { source: 55, target: 82, value: 1, valueid: 'targetab', paperName: 'LLN14', process: 'LLN14_4', id: 'LLN14-24', cluster: 'rvc2', imgUrl: 'xWQU5gc.jpg', color: 'repVisVarColor' },
    {
        source: 119,
        target: 21,
        value: 1,
        valueid: 'repg',
        paperName: 'MA16',
        process: 'MA16_4',
        id: 'MA16-3',
        cluster: 'rvc2',
        imgUrl: '69BWuDV.png',
        color: 'targetLinkFourColor',
        status: 'selected',
    },
    {
        source: 119,
        target: 27,
        value: 1,
        valueid: 'repg',
        paperName: 'MA16',
        process: 'MA16_4',
        id: 'MA16-4',
        cluster: 'rvc2',
        imgUrl: '69BWuDV.png',
        color: 'targetLinkFourColor',
        status: 'selected',
    },
    { source: 21, target: 46, value: 1, valueid: 'repg', paperName: 'MA16', process: 'MA16_4', id: 'MA16-9', cluster: 'rvc2', imgUrl: '69BWuDV.png', color: 'intFiveLinkColor' },
    { source: 27, target: 46, value: 1, valueid: 'repg', paperName: 'MA16', process: 'MA16_4', id: 'MA16-10', cluster: 'rvc2', imgUrl: '69BWuDV.png', color: 'intFiveLinkColor' },
    { source: 46, target: 68, value: 1, valueid: 'repg', paperName: 'MA16', process: 'MA16_4', id: 'MA16-16', cluster: 'rvc2', imgUrl: '69BWuDV.png', color: 'intFiveLinkColor' },
    { source: 68, target: 82, value: 1, valueid: 'repg', paperName: 'MA16', process: 'MA16_4', id: 'MA16-19', cluster: 'rvc2', imgUrl: '69BWuDV.png', color: 'repVisVarColor' },
    {
        source: 128,
        target: 7,
        value: 1,
        valueid: ['targetca', 'repa'],
        paperName: 'SCS17',
        process: 'SCS17_1',
        id: 'SCS17-0',
        cluster: 'rvc2',
        imgUrl: 'h29usSh.jpg',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 128,
        target: 11,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'SCS17',
        process: 'SCS17_2',
        id: 'SCS17-1',
        cluster: 'rvc2',
        imgUrl: 'h29usSh.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 7, target: 44, value: 1, valueid: ['targetca', 'repa'], paperName: 'SCS17', process: 'SCS17_1', id: 'SCS17-7', cluster: 'rvc2', imgUrl: 'h29usSh.jpg', color: 'intThreeLight2LinkColor' },
    {
        source: 44,
        target: 63,
        value: 1,
        valueid: ['targetca', 'repa'],
        paperName: 'SCS17',
        process: 'SCS17_1',
        id: 'SCS17-8',
        cluster: 'rvc2',
        imgUrl: 'h29usSh.jpg',
        color: 'intThreeLight2LinkColor',
    },
    { source: 63, target: 82, value: 1, valueid: ['targetca', 'repa'], paperName: 'SCS17', process: 'SCS17_1', id: 'SCS17-12', cluster: 'rvc2', imgUrl: 'h29usSh.jpg', color: 'repVisVarColor' },
    {
        source: 11,
        target: 34,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'SCS17',
        process: 'SCS17_2',
        id: 'SCS17-14',
        cluster: 'rvc2',
        imgUrl: 'h29usSh.jpg',
        color: 'intOneLightLinkColor',
    },
    {
        source: 11,
        target: 44,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'SCS17',
        process: 'SCS17_2',
        id: 'SCS17-15',
        cluster: 'rvc2',
        imgUrl: 'h29usSh.jpg',
        color: 'intThreeLight2LinkColor',
    },
    {
        source: 11,
        target: 46,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'SCS17',
        process: 'SCS17_2',
        id: 'SCS17-16',
        cluster: 'rvc2',
        imgUrl: 'h29usSh.jpg',
        color: 'intFiveLinkColor',
    },
    {
        source: 34,
        target: 63,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'SCS17',
        process: 'SCS17_2',
        id: 'SCS17-17',
        cluster: 'rvc2',
        imgUrl: 'h29usSh.jpg',
        color: 'intOneLightLinkColor',
    },
    {
        source: 44,
        target: 63,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'SCS17',
        process: 'SCS17_2',
        id: 'SCS17-18',
        cluster: 'rvc2',
        imgUrl: 'h29usSh.jpg',
        color: 'intThreeLight2LinkColor',
    },
    {
        source: 46,
        target: 63,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'SCS17',
        process: 'SCS17_2',
        id: 'SCS17-19',
        cluster: 'rvc2',
        imgUrl: 'h29usSh.jpg',
        color: 'intFiveLinkColor',
    },
    {
        source: 63,
        target: 82,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'SCS17',
        process: 'SCS17_2',
        id: 'SCS17-23',
        cluster: 'rvc2',
        imgUrl: 'h29usSh.jpg',
        color: 'repVisVarColor',
    },
    {
        source: 150,
        target: 6,
        value: 1,
        valueid: ['targetba', 'repc'],
        paperName: 'MLG06',
        process: 'MLG06_1',
        id: 'MLG06-0',
        cluster: 'rvc2',
        imgUrl: 'qXOBST8.jpg',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 150,
        target: 12,
        value: 1,
        valueid: ['targetba', 'repc'],
        paperName: 'MLG06',
        process: 'MLG06_2',
        id: 'MLG06-1',
        cluster: 'rvc2',
        imgUrl: 'qXOBST8.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 6, target: 39, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_1', id: 'MLG06-2', cluster: 'rvc2', imgUrl: 'qXOBST8.jpg', color: 'intTwoLinkColor' },
    { source: 12, target: 39, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_2', id: 'MLG06-3', cluster: 'rvc2', imgUrl: 'qXOBST8.jpg', color: 'intTwoLinkColor' },
    { source: 12, target: 49, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_2', id: 'MLG06-5', cluster: 'rvc2', imgUrl: 'qXOBST8.jpg', color: 'intFiveLight2LinkColor' },
    { source: 39, target: 53, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_1', id: 'MLG06-6', cluster: 'rvc2', imgUrl: 'qXOBST8.jpg', color: 'intTwoLinkColor' },
    { source: 39, target: 53, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_2', id: 'MLG06-7', cluster: 'rvc2', imgUrl: 'qXOBST8.jpg', color: 'intTwoLinkColor' },
    { source: 42, target: 53, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_1', id: 'MLG06-8', cluster: 'rvc2', imgUrl: 'qXOBST8.jpg', color: 'intThreeLightLinkColor' },
    { source: 49, target: 53, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_2', id: 'MLG06-9', cluster: 'rvc2', imgUrl: 'qXOBST8.jpg', color: 'intFiveLight2LinkColor' },
    { source: 53, target: 82, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_1', id: 'MLG06-16', cluster: 'rvc2', imgUrl: 'qXOBST8.jpg', color: 'repVisVarColor' },
    { source: 53, target: 82, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_2', id: 'MLG06-17', cluster: 'rvc2', imgUrl: 'qXOBST8.jpg', color: 'repVisVarColor' },
];
